import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockOutline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 32L28 32L28 15.6667L12 15.6667L12 32Z",
			stroke: "#281E38",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0004 6.33334C16.0004 6.33334 14.2861 9.59068 14.2861 12.1667V15.6667H25.7147V12.1667C25.7147 9.59068 24.0004 6.33334 20.0004 6.33334Z",
			stroke: "#281E38",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 21.5V25",
			stroke: "#281E38",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0003 26.1667C20.6315 26.1667 21.1431 25.6443 21.1431 25C21.1431 24.3557 20.6315 23.8333 20.0003 23.8333C19.3691 23.8333 18.8574 24.3557 18.8574 25C18.8574 25.6443 19.3691 26.1667 20.0003 26.1667Z",
			stroke: "#281E38",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgLockOutline);
export default ForwardRef;
